import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'

import Title from 'components/atoms/Title'
import InputControl from 'components/molecules/InputControl'
import InputDate from 'components/molecules/InputDate'
import Checkbox from 'components/molecules/Checkbox'

import { OrderFields } from 'types/order'
import { selectOrderWrite } from 'store/order/order.selectors'

import { changeOrderHandler } from 'store/order/order.actions'
import { getDateForServer } from 'utils/date'

import { InsuranceProps } from './index'
import { useSyncInsuredCargo } from '../../hooks/useInsuranceForm'

const Manager: React.FC<InsuranceProps> = ({ onChange }) => {
  const dispatchStore = useDispatch()
  const form = useSelector(selectOrderWrite)
  useSyncInsuredCargo(form, onChange)

  const handleCheckboxChange = (checked: boolean, id?: string) => {
    onChange(String(checked), id)
  }

  const setRouteDate = (daysToAdd: number) => {
    const date = new Date()
    date.setDate(date.getDate() + daysToAdd)
    dispatchStore(changeOrderHandler({ [OrderFields.ROUTE_DATE_START]: getDateForServer(date) }))
  }

  return (
    <>
      <Title text="Страхование груза" />
      <ul className="list-group needs-validation">
        <li className="list-group-item row">
          <InputControl
            type="text"
            id="meta.insuredInn"
            value={String(form[OrderFields.META]?.insuredInn || '')}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="ИНН страхующего:"
          />
          <InputControl
            type="text"
            id="meta.insuredName"
            value={String(form[OrderFields.META]?.insuredName || '')}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Название страхующего:"
          />
          <InputControl
            type="text"
            id="meta.insuredEmail"
            value={String(form[OrderFields.META]?.insuredEmail || '')}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Email, куда отправить полис:"
          />
        </li>

        <li className="list-group-item row">
          <InputControl
            type="text"
            id={OrderFields.LOGISTIC_INN}
            value={form[OrderFields.LOGISTIC_INN] || ''}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="ИНН перевозчика:"
          />
        </li>

        <li className="list-group-item row">
          <InputDate
            id={OrderFields.ROUTE_DATE_START}
            value={form[OrderFields.ROUTE_DATE_START] || ''}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Дата начала рейса:"
          />
          <div className="col-lg-4 col-md-6 col-sm-12 p-0 d-flex" style={{ marginTop: '12px' }}>
            <Button className="p-0" style={{ flex: 1, marginRight: '4px' }} onClick={() => setRouteDate(0)}>
              Сегодня
            </Button>
            <Button className="p-0" style={{ flex: 1, marginLeft: '4px' }} onClick={() => setRouteDate(1)}>
              Завтра
            </Button>
          </div>
          <InputDate
            id="meta.routeDateEnd"
            value={String(form[OrderFields.META]?.routeDateEnd || '')}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Дата конца рейса:"
          />
        </li>

        <li className="list-group-item row">
          <InputControl
            type="text"
            id={OrderFields.ROUTE_TRIP}
            value={form[OrderFields.ROUTE_TRIP] || ''}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Маршрут:"
          />
          <InputControl
            type="text"
            id={OrderFields.CARGO}
            value={form[OrderFields.CARGO] || ''}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Груз:"
          />
          <InputControl
            type="number"
            id="meta.costOfCargo"
            value={String(form[OrderFields.META]?.costOfCargo || '')}
            onChangeHandler={onChange}
            className="col-lg-4 col-md-6 col-sm-12"
            label="Стоимость груза:"
          />
        </li>

        <li className="list-group-item row">
          <Checkbox
            id="meta.insuranceConfirmed"
            value={form[OrderFields.META]?.insuranceConfirmed === 'true'}
            onChangeHandler={handleCheckboxChange}
            label="Подтверждаю страхование"
          />
        </li>
      </ul>
    </>
  )
}

export default Manager
